<vw-page
  [page]="page"
  *ngIf="page"
  [alwaysFillNav]="true"
  [showDealerInformation]="true"
>
  <div class="product-page">
    <vw-page-header class="product-hero">
      <div breadcrumbs *ngIf="product?.media && !!breadcrumbs.length">
        <vw-breadcrumbs
          [breadcrumbs]="breadcrumbs"
          [currentPage]="productName"
        ></vw-breadcrumbs>
      </div>
      <div class="product-header" header>
        <div class="row">
          <div class="col-12">
            <span class="product-hero-title">
              {{
                (channelRequestService.channelRequest &&
                channelRequestService.channelRequest.shoppingCart &&
                channelRequestService.channelRequest.shoppingCart.vehicle
                  ? "productBasedOnYourVehicle"
                  : "productNotBasedOnYourVehicle"
                ) | translate
              }}
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p
              class="mb-0 product-reg color-white bold me-3"
              *ngIf="
                channelRequestService.channelRequest &&
                channelRequestService.channelRequest.shoppingCart &&
                channelRequestService.channelRequest.shoppingCart.vehicle
              "
            >
              {{
                channelRequestService.channelRequest.shoppingCart.vehicle
                  | vehicle
              }}
            </p>
          </div>
        </div>
      </div>
    </vw-page-header>

    <div class="container-fluid container-md">
      <div *ngIf="productLoading" class="row">
        <div class="col-12 d-flex justify-content-center">
          <vw-loading></vw-loading>
        </div>
      </div>
      <div class="mt-4" *ngIf="productError">
        <vw-alert
          [message]="'errorMessages.productError' | translate"
          [type]="'danger'"
        ></vw-alert>
      </div>

      <div class="product-main-content" *ngIf="product">
        <div class="row product-info">
          <div
            class="product-message product-message--campaign mt-4"
            *ngIf="product.isCampaign && !!product.campaign"
          >
            <span class="campaign-title">{{ "campaign" | translate }}</span>
            <span class="campaign-dates"
              >{{ product.campaign.startDate | date: "d LLL" }} -
              {{ product.campaign.endDate | date: "d LLL" }}</span
            >
          </div>
          <div class="col-12 col-lg-7" *ngIf="images && images.length">
            <vw-image-carousel
              [images]="images"
              [product]="product"
              [productMessages]="productMessages"
            ></vw-image-carousel>
          </div>
          <div class="col-12 col-lg-7" *ngIf="!images.length">
            <span *ngFor="let pm of productMessages" class="product-message">{{
              pm
            }}</span>

            <img
              class="img-fluid"
              [src]="productImageFallbackURL"
              [alt]="product.sku"
            />
          </div>
          <div class="col-12 col-lg-5">
            <div class="row">
              <div class="col-12">
                <p class="h5 product-information-title">
                  {{ productName }}
                </p>
              </div>
              <div class="col-12">
                <p class="product-information-articlenr">
                  {{ "product.articleNr" | translate: { artNr: product.sku } }}
                </p>
              </div>
              <div *ngIf="productDescription" class="col-12">
                <p
                  class="product-information-description"
                  [innerHTML]="productDescription"
                ></p>
              </div>
              <div *ngIf="!!product.productSubset?.length" class="col-12">
                <span class="d-block bold mb-2">{{
                  "productPage.includedInProductSubset" | translate
                }}</span>
                <div
                  *ngFor="let p of product.productSubset"
                  class="product-subset"
                >
                  <p class="mb-0">
                    <span class="bold"
                      >{{ p.quantity }}
                      <ng-container *ngIf="p.product?.unitType">{{
                        p.product?.unitType?.suffix
                      }}</ng-container>
                    </span>
                    <span>
                      {{
                        p.product?.media
                          | media
                            : mediaCategoryTypeNames.ProductName
                            : mediaTypes.Text
                      }}
                    </span>
                  </p>
                </div>
              </div>

              <div
                class="col-12 mb-3"
                *ngIf="product.price && product.price.salesPrice != null"
              >
                <div
                  *ngIf="
                    product.isCampaign && !!product.campaign;
                    else noCampaign
                  "
                  class="d-flex flex-column align-items-end"
                >
                  <div class="campaign-percentage">
                    {{ product.price.adjustmentPercentage | campaignDiscount }}
                  </div>
                  <div class="campaign-price">
                    <p class="h3 bold text-start text-lg-end">
                      {{ product.price.salesPrice | price }}
                    </p>
                    <div
                      *ngIf="!!product.price.listPrice"
                      class="d-flex justify-content-end align-items-center"
                    >
                      <span class="campaign-original-price">{{
                        product.price.listPrice | price
                      }}</span>
                      <i
                        class="fal fa-info-circle"
                        title="{{ 'price.latest' | translate }}"
                      ></i>
                    </div>
                  </div>
                </div>
                <ng-template #noCampaign>
                  <p class="h4 bold text-start text-lg-end">
                    {{ product.price.salesPrice | price }}
                  </p>
                </ng-template>
                <div
                  class="brand-card-container"
                  *ngIf="product.price.salesPrice >= 500"
                >
                  <vw-brand-card></vw-brand-card>
                  <p class="h4 bold text-start text-lg-end monthly-price">
                    {{ product.price.salesPrice | price: true }}
                  </p>
                </div>
              </div>
              <div class="col-12 mt-4">
                <form
                  [formGroup]="form"
                  class="d-flex justify-content-start justify-content-lg-end quantity"
                  *ngIf="shoppingCartService.shoppingCart"
                >
                  <vw-text-box
                    [id]="'quantity'"
                    [type]="'number'"
                    [parentForm]="form"
                    [formControlProp]="'quantity'"
                  >
                  </vw-text-box>

                  <vw-button
                    class="ms-2"
                    (click)="addToCart()"
                    [primary]="true"
                    [text]="'productPage.add' | translate"
                    [icon]="'fal fa-shopping-cart ms-1'"
                    [disabled]="
                      !form.valid ||
                      !(
                        product
                        | productAddable
                          : shoppingCartService.shoppingCart
                          : form.value.quantity ?? 0
                      )
                    "
                  ></vw-button>
                </form>
                <div
                  *ngIf="product.warehouseStockStatus"
                  class="d-flex justify-content-start justify-content-lg-end mt-2 align-items-center"
                >
                  <span class="me-1">{{
                    "productPage.warehouseStockStatus" | translate
                  }}</span>
                  <vw-badge
                    [type]="
                      product.warehouseStockStatus ===
                      warehouseStockStatusEnum.High
                        ? 'badge-success'
                        : product.warehouseStockStatus ===
                            warehouseStockStatusEnum.Medium
                          ? 'badge-warning'
                          : 'badge-secondary'
                    "
                    [text]="
                      'warehouseStockStatus.' + product.warehouseStockStatus
                        | translate
                    "
                    [icon]="
                      product.warehouseStockStatus ===
                      warehouseStockStatusEnum.High
                        ? 'far fa-check'
                        : product.warehouseStockStatus ===
                            warehouseStockStatusEnum.Medium
                          ? 'fa-long-arrow-right fal'
                          : ''
                    "
                  ></vw-badge>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="product-properties">
              <vw-toggleable
                *ngFor="let group of product.productTags | groupTags | keyvalue"
                [entireHeaderClickable]="true"
              >
                <div header>
                  <h4 class="mb-0">
                    {{ "tagGroups." + group.key | translate }}
                  </h4>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <tbody>
                      <tr *ngFor="let tag of group.value" class="border-bottom">
                        <td class="bold w-50">
                          <span>{{
                            "tagTypes." + tag.tag?.tagType?.name | translate
                          }}</span>
                        </td>
                        <td class="w-50 value">
                          <span>
                            {{
                              tag.tag?.value === "1"
                                ? ("yes" | translate)
                                : tag.tag?.value === "0"
                                  ? ("no" | translate)
                                  : tag.tag?.value
                            }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </vw-toggleable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="product && (technicalInformation || linkEULabelingTyres)"
      class="container-fluid product-information-text"
    >
      <div class="row">
        <div class="col-12">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 col-lg-6 product-info">
                <h4 class="bold">
                  {{ "productPage.technicalInformation" | translate }}
                </h4>
                <p
                  *ngIf="technicalInformation"
                  [innerHTML]="technicalInformation"
                ></p>

                <vw-link
                  *ngIf="linkEULabelingTyres"
                  [regularLink]="true"
                  [text]="'productPage.linkEULabelingTyres' | translate"
                  [href]="linkEULabelingTyres"
                  [icon]="'fal fa-long-arrow-right'"
                  [target]="'_blank'"
                ></vw-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <vw-product-up-sale
    *ngIf="product != null && product.sku != null"
    [sku]="product.sku"
  >
  </vw-product-up-sale>

  <vw-recent-products
    *ngIf="product"
    [excludedSKU]="product.sku"
    [productCarouselBackgroundColor]="true"
  >
  </vw-recent-products>
</vw-page>
